const QUESTIONNAIRE_PERMISSION_KEYS = Object.freeze({
  templates: "問卷範本設定",
  categories: "問卷對應服務分類",
  services: "問卷服務關聯設定",
});

const QUESTIONNAIRE_PERMISSION_BY_ROUTE = Object.freeze({
  "questionnaire-templates": QUESTIONNAIRE_PERMISSION_KEYS.templates,
  "questionnaire-editor": QUESTIONNAIRE_PERMISSION_KEYS.templates,
  "questionnaire-category-link": QUESTIONNAIRE_PERMISSION_KEYS.categories,
  "questionnaire-category-edit": QUESTIONNAIRE_PERMISSION_KEYS.categories,
  "questionnaire-service-link": QUESTIONNAIRE_PERMISSION_KEYS.services,
  "questionnaire-service-edit": QUESTIONNAIRE_PERMISSION_KEYS.services,
});

const QUESTIONNAIRE_PERMISSION_ORDER = Object.freeze([
  QUESTIONNAIRE_PERMISSION_KEYS.templates,
  QUESTIONNAIRE_PERMISSION_KEYS.categories,
  QUESTIONNAIRE_PERMISSION_KEYS.services,
]);

const QUESTIONNAIRE_PERMISSION_DISPLAY_LABELS = Object.freeze({
  [QUESTIONNAIRE_PERMISSION_KEYS.templates]: "問卷－範本設定",
  [QUESTIONNAIRE_PERMISSION_KEYS.categories]: "問卷－對應服務分類",
  [QUESTIONNAIRE_PERMISSION_KEYS.services]: "問卷－服務關聯設定",
});

function resolveQuestionnairePermissionKey(routeKey) {
  return QUESTIONNAIRE_PERMISSION_BY_ROUTE[routeKey];
}

function getQuestionnairePermissionDisplayLabel(permissionKey) {
  return QUESTIONNAIRE_PERMISSION_DISPLAY_LABELS[permissionKey] || permissionKey;
}

export {
  QUESTIONNAIRE_PERMISSION_KEYS,
  QUESTIONNAIRE_PERMISSION_BY_ROUTE,
  QUESTIONNAIRE_PERMISSION_ORDER,
  QUESTIONNAIRE_PERMISSION_DISPLAY_LABELS,
  resolveQuestionnairePermissionKey,
  getQuestionnairePermissionDisplayLabel,
};
